/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Tabs as AntDTabs, TabsProps as AntDTabsProps } from 'antd';
import { CSSProperties } from 'react';

export type TabsProps = {
  className?: string;
  style?: CSSProperties;
  activeKey?: AntDTabsProps['activeKey'];
  defaultActiveKey?: AntDTabsProps['defaultActiveKey'];
  onChange?: AntDTabsProps['onChange'];
  items: { key: string; label: string; children: React.ReactNode }[];
  tabBarExtraContent?: AntDTabsProps['tabBarExtraContent'];
};

export function Tabs({
  items,
  activeKey,
  defaultActiveKey,
  onChange,
  className,
  style,
  tabBarExtraContent,
}: TabsProps) {
  return (
    <AntDTabs
      className={className}
      style={style}
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      items={items}
      onChange={onChange}
      destroyInactiveTabPane
      tabBarExtraContent={tabBarExtraContent}
    />
  );
}
